// ref: http://media.twiliocdn.com/sdk/js/chat/releases/6.0.0/docs/modules.html#ConnectionState
export const TWILIO_CONNECTION_STATE = {
  CONNECTED: 'connected',
  CONNECTING: 'connecting',
  DISCONNECTED: 'disconnected',
  DISCONNECTING: 'disconnecting',
  DENIED: 'denied',
  UNKNOWN: 'unknown',
};

export const CONVERSATION_MESSAGES_MAX = 100;

export const PROPEL_JWT_TOKEN_TTL_MINUTES = 60; // ask-mojo = 24hrs. Authenticate-avatar = 1hr. Only use lesser for consistency.
export const INACTIVITY_TIMEOUT_MINUTES = PROPEL_JWT_TOKEN_TTL_MINUTES;

export const PARTICIPANT_NAME_SYSTEM_FRIENDLY = 'Sebastian';
export const PARTICIPANT_NAME_SYSTEM_ACTUAL = 'system';

export const PARTICIPANT_PREFIX = {
  CUSTOMER: 'AVATAR_CUSTOMER',
  ADVOCATE: 'AVATAR_SUPPORT',
};

export const PARTICIPANT_SYSTEM_IMAGE = `${process.env.REACT_APP_GCP_STORAGE_BASE_URL}/assets/advocate-avatars/sebastian.png`;

export const PARTICIPANT_ADVOCATE_IMAGE_MAP: { [aliasName: string]: string } = {
  sebastian: PARTICIPANT_SYSTEM_IMAGE,
  DEFAULT: `${process.env.REACT_APP_GCP_STORAGE_BASE_URL}/assets/advocate-avatars/amanda.jpg`,
  amanda: `${process.env.REACT_APP_GCP_STORAGE_BASE_URL}/assets/advocate-avatars/amanda.jpg`,
  athena: `${process.env.REACT_APP_GCP_STORAGE_BASE_URL}/assets/advocate-avatars/athena.jpg`,
  elijah: `${process.env.REACT_APP_GCP_STORAGE_BASE_URL}/assets/advocate-avatars/elijah.jpg`,
  jacob: `${process.env.REACT_APP_GCP_STORAGE_BASE_URL}/assets/advocate-avatars/jacob.jpg`,
  kevin: `${process.env.REACT_APP_GCP_STORAGE_BASE_URL}/assets/advocate-avatars/kevin.jpg`,
  peter: `${process.env.REACT_APP_GCP_STORAGE_BASE_URL}/assets/advocate-avatars/peter.jpg`,
  phoebe: `${process.env.REACT_APP_GCP_STORAGE_BASE_URL}/assets/advocate-avatars/phoebe.jpg`,
  samantha: `${process.env.REACT_APP_GCP_STORAGE_BASE_URL}/assets/advocate-avatars/samantha.jpg`,
  sophia: `${process.env.REACT_APP_GCP_STORAGE_BASE_URL}/assets/advocate-avatars/sophia.jpg`,
  trina: `${process.env.REACT_APP_GCP_STORAGE_BASE_URL}/assets/advocate-avatars/trina.jpg`,
  tyler: `${process.env.REACT_APP_GCP_STORAGE_BASE_URL}/assets/advocate-avatars/tyler.jpg`,
  victoria: `${process.env.REACT_APP_GCP_STORAGE_BASE_URL}/assets/advocate-avatars/victoria.jpg`,
};
